import axios from 'axios';
import Config from '../config';
import { AppRoutes, WebRoutes } from '../components/routes/route.path';
import { UserService } from './UserService';
import store from "../stores/app-store";


const login = (userName: string, password: string, stayLoggedIn: boolean, navigate) => {
    var data = new URLSearchParams();
    data.append("username", userName);
    data.append("password", password);
    data.append("grant_type", "password");
    data.append("keep_me_signed_in", stayLoggedIn ? "True" : "False");

    var conf = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } };
    return axios.post(`${Config.API_URL}/api/v1/user/connect/token`, data, conf).then(async (res) => {
        var dt = new Date();
        dt.setSeconds(dt.getSeconds() + res.data.expires_in);
        res.data.expires_in = dt;
        localStorage.setItem("user-token", JSON.stringify(res.data));
        let token = res.data.access_token;
        const [, payloadBase64] = token.split('.');
        const payloadString = atob(payloadBase64);
        const payload = JSON.parse(payloadString);
        getCurrentUser(payload.EmailId, navigate);

    }).catch((err) => {
        throw err;
    })
}

const exchangeToken = async (data, token, navigate) => {
    const headers = {
        "authorization": `Bearer ${token}`
    }
    axios.post(`${Config.API_URL}/api/v1/user/exchange`, data, { headers }).then(async (res) => {
        var dt = new Date();
        dt.setSeconds(dt.getSeconds() + res.data.expires_in);
        res.data.expires_in = dt;
        localStorage.setItem("user-token", JSON.stringify(res.data));
        let token = res.data.access_token;
        const [, payloadBase64] = token.split('.');
        const payloadString = atob(payloadBase64);
        const payload = JSON.parse(payloadString);
        getCurrentUser(payload.EmailId, navigate);
    }).catch((err) => {
        throw err;
    });
}

const getCurrentUser = async (id, navigate) => {

    await UserService.getCurrentUser(id).then((res) => {
        UserService.getCurrentChannelESignUserFromLocalStorage().RoleID == 1 ? navigate(AppRoutes.ADMIN) : navigate(store.getState().ISSmsLogin ? AppRoutes.FALKON_DOCS : AppRoutes.DASHBOARD)
    }).catch((err) => {

    })
}

const getToken = () => {
    var token = localStorage.getItem("user-token");
    return !!token ? JSON.parse(localStorage.getItem("user-token").toString()!) : {};
};

const isUserLoggedIn = () => {
    let isRedirect = window.location.href.includes("/redirect")
    return !!getToken() && (isRedirect ? true : !!JSON.parse(localStorage.getItem("current-user")))
}

const logout = () => {
    localStorage.clear();
    window.location.replace(AppRoutes.SIGN_IN);
};

const verifyEmailToken = (token) => {
    if (token) {
        return axios.post(`${Config.API_URL}/api/v1/user/verify/email`, { token })
    }
}

const verifyInvitationToken = (token) => {
    if (token) {
        return axios.post(`${Config.API_URL}/api/v1/user/verify/invite`, { token })
    }
}

const resetpassword = (data) => {
    return axios.post(`${Config.API_URL}/api/v1/user/signup/invite`, data)
}

const forgetpassword = (email) => {
    return axios.post(`${Config.API_URL}/api/v1/user/forgot/password`, { email })
}

const googleSignIn = (auth_code: string, navigate) => {
    return axios.post(`${Config.API_URL}/api/v1/user/google/signup`, { auth_code }).then((res) => {
        var dt = new Date();
        dt.setSeconds(dt.getSeconds() + res.data.expires_in);
        res.data.expires_in = dt;
        localStorage.setItem("user-token", JSON.stringify(res.data));
        let token = res.data.access_token;
        const [, payloadBase64] = token.split('.');
        const payloadString = atob(payloadBase64);
        const payload = JSON.parse(payloadString);
        getCurrentUser(payload.EmailId, navigate)
    }).catch((err) => {
        throw err
    })
}

const microsoftSignIn = (auth_code: string, navigate) => {
    return axios.post(`${Config.API_URL}/api/v1/user/microsoft/signup`, { auth_code }).then((res) => {
        var dt = new Date();
        dt.setSeconds(dt.getSeconds() + res.data.expires_in);
        res.data.expires_in = dt;
        localStorage.setItem("user-token", JSON.stringify(res.data));
        let token = res.data.access_token;
        const [, payloadBase64] = token.split('.');
        const payloadString = atob(payloadBase64);
        const payload = JSON.parse(payloadString);
        getCurrentUser(payload.EmailId, navigate)
    }).catch((err) => {
        throw err
    })
}

const isTokenExpired = () => {
    var token = getToken();
    return !!token && !!token.access_token && !!token.refresh_token && !!token.expires_in && new Date(token.expires_in) <= new Date();
};

const getGoogleUrl = (openInTeams: boolean, navigate?: any) => {
    const rootUrl = `https://accounts.google.com/o/oauth2/v2/auth`;
    const options = {
        redirect_uri: window.location.origin + "/google/redirect",
        client_id: Config.LOGIN_GOOGLE_CLIENT_ID,
        access_type: 'offline',
        response_type: 'code',
        prompt: 'consent',
        scope: [
            'https://www.googleapis.com/auth/userinfo.profile',
            'https://www.googleapis.com/auth/userinfo.email',
        ].join(' '),
    };
    const qs = new URLSearchParams(options).toString();
    const authUrl = `${rootUrl}?${qs}`;
    window.top.location.href = authUrl;
};

const getMicrosoftUrl = (openInTeams: boolean, navigate?: any) => {
    const rootUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize`;
    const options = {
        redirect_uri: window.location.origin + WebRoutes.LOGIN_REDIRECT.replace(":login", "microsoft"),
        client_id: Config.REACT_APP_LOGIN_MICROSOFT_CLIENT_ID,
        response_type: 'code',
        prompt: 'consent',
        scope: 'User.Read',
    };

    const qs = new URLSearchParams(options).toString();
    const authUrl = `${rootUrl}?${qs}`;
    window.location.href = authUrl;
};

const refreshToken = () => {
    const tokenData = getToken();

    if (!tokenData || !tokenData.refresh_token) {
        return Promise.reject(new Error('No refresh token available'));
    }

    const data = new URLSearchParams();
    data.append("refresh_token", tokenData.refresh_token);
    data.append("grant_type", "refresh_token");

    const conf = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } };
    return axios.post(`${Config.API_URL}/api/v1/user/connect/token`, data, conf)
        .then((res) => {
            const dt = new Date();
            dt.setSeconds(dt.getSeconds() + res.data.expires_in);
            res.data.expires_in = dt;
            localStorage.setItem("user-token", JSON.stringify(res.data));
            return res.data;
        })
        .catch((err) => {
            logout();
            throw err;
        });
};

const loggedIn = () => {
    var token = getToken();
    return !!token && !!token.access_token && (!!token.sso || ((!!token.expires_in && new Date(token.expires_in) > new Date()) || !!token.refresh_token));
};

const is2FACompleted = () => {
    return localStorage.getItem("2FAVerified")?.toString() !== null && localStorage.getItem("2FAVerified")?.toString() === "true"
}

const isNewUser = () => {
    var user = JSON.parse(localStorage.getItem("current-user")!);
    return !!user && user.lastLoggedIn == null
}

const clearSession = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace(AppRoutes.SIGN_IN);
}


export const AuthService = {
    login,
    clearSession,
    loggedIn,
    is2FACompleted,
    isNewUser,
    getToken,
    isUserLoggedIn,
    logout,
    verifyEmailToken,
    verifyInvitationToken,
    resetpassword,
    forgetpassword,
    googleSignIn,
    microsoftSignIn,
    getGoogleUrl,
    getMicrosoftUrl,
    isTokenExpired,
    refreshToken,
    exchangeToken
}
